
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Database } from "@/integrations/supabase/types";

type Prompt = Database["public"]["Tables"]["prompts"]["Row"];

interface PromptsListProps {
  prompts: Prompt[];
  isLoading: boolean;
}

export const PromptsList: React.FC<PromptsListProps> = ({ prompts, isLoading }) => {
  return (
    <Card className="col-span-1 dark:bg-white">
      <CardHeader>
        <CardTitle className="dark:text-gray-600">Prompts Populares</CardTitle>
        <CardDescription>
          Os prompts mais utilizados na plataforma
        </CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
          </div>
        ) : prompts.length > 0 ? (
          <div className="space-y-4">
            {prompts.map((prompt) => (
              <div key={prompt.id} className="border-b pb-2">
                <h3 className="font-medium dark:text-gray-600">{prompt.titulo}</h3>
                <p className="text-sm text-gray-500">
                  {prompt.area} • {prompt.total_uso} usos
                </p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-gray-500">
            Nenhum prompt disponível no momento.
          </p>
        )}
      </CardContent>
    </Card>
  );
};
